var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg63(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lower right arrow / 24 / Outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.9963 5.99628C16.7311 5.99628 16.4767 6.10164 16.2892 6.28917C16.1016 6.47671 15.9963 6.73106 15.9963 6.99628V14.5863L7.70628 6.28628C7.51798 6.09798 7.26258 5.99219 6.99628 5.99219C6.72998 5.99219 6.47458 6.09798 6.28628 6.28628C6.09798 6.47458 5.99219 6.72998 5.99219 6.99628C5.99219 7.26258 6.09798 7.51798 6.28628 7.70628L14.5863 15.9963H6.99628C6.73106 15.9963 6.47671 16.1016 6.28917 16.2892C6.10164 16.4767 5.99628 16.7311 5.99628 16.9963C5.99628 17.2615 6.10164 17.5159 6.28917 17.7034C6.47671 17.8909 6.73106 17.9963 6.99628 17.9963H16.9963C17.127 17.9947 17.2561 17.9675 17.3763 17.9163C17.6206 17.8148 17.8148 17.6206 17.9163 17.3763C17.9675 17.2561 17.9947 17.127 17.9963 16.9963V6.99628C17.9963 6.73106 17.8909 6.47671 17.7034 6.28917C17.5159 6.10164 17.2615 5.99628 16.9963 5.99628Z",
    fill: "#E83310"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg63);
export default __webpack_public_path__ + "static/media/svg63.a198f8126ed424f5915ffe566615b7e7.svg";
export { ForwardRef as ReactComponent };